import React, { useCallback, useEffect } from 'react';
import { GenericStep } from '@/components/FullWidthTemplate/GenericStep';
import * as Styles from './GenericSuccess.styles';
import { IconCheck, IconCircleCheck } from 'gatorcomponents';
import { GenericSuccessProps } from './GenericSuccess.types';
import WpScreenBR from '@/media/onboarding/wp-ai-success-br.webp';

const GenericSuccess = ({
  locales = {
    title: 'Success!',
    subtitle: '',
    description: '',
    infoList: [],
    note: '',

  }, buttonsProps, imageSrc = WpScreenBR, cleanUp, icon,
}) => {
  const componentProps = {
    testId: 'generic-success-step',
    buttonsProps,
    imageSrc,
  };

  const handleUnmount = useCallback(() => {
    cleanUp && cleanUp();
  }, [cleanUp]);

  useEffect(() => () => {
    handleUnmount();
  },
  [handleUnmount]);

  return (
    <GenericStep {...componentProps}>
      <Styles.Wrapper>
        <Styles.TitleContainer>
          {!icon && <IconCircleCheck color="primaryMedium" size="lg" />}
          {icon && icon}
          <Styles.Title>
            {locales.title}
          </Styles.Title>
        </Styles.TitleContainer>

        {locales.subtitle && (
          <Styles.Subtitle>{locales.subtitle}</Styles.Subtitle>
        )}

        {locales.description && (
          <Styles.Description>{locales.description}</Styles.Description>
        )}

        <Styles.InfosList>
          {locales.infoList.map(infoText => (
            <Styles.ListItem key={infoText}>
              <IconCheck color="primaryMedium" />
              <Styles.Text>{infoText}</Styles.Text>
            </Styles.ListItem>
          ))}

          {locales.note && (
            <Styles.Note>{locales.note}</Styles.Note>
          )}
        </Styles.InfosList>
      </Styles.Wrapper>
    </GenericStep>
  );
};

GenericSuccess.propTypes = GenericSuccessProps;

export default GenericSuccess;
